import { useEffect, useState } from "react";
import Spinner from "../components/Spinner";
import Product from "../components/Product";
import ProductSlider from "../components/ProductSlider";

const Home = () => {
  const API_URL = "https://fakestoreapi.com/products";

  const [loading , setLoading]= useState(false);
  const [posts,setPosts]=useState([]);

  async function fetchProductData(){
     setLoading(true);
     try {
        const res= await fetch(API_URL);
        const data=await res.json();

        setPosts(data);
     } catch (error) {
      console.log("error aagya jii");
      setPosts([]);
     }
     setLoading(false);

  }

  useEffect(()=>{
    fetchProductData();
  },[])
  return (
  <div className="overflow-x-hidden">
      {

      loading?<Spinner/> :
      posts.length > 0 ? 
      (<div className="">
          <div className="pb-10"><ProductSlider/></div>
            
             <h1 className="text-3xl text-center font-semibold text-[#273232]">SHOP NOW</h1>
            <div className="grid  xs:gridcols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 max-w-6xl p-2 pb-16 mx-auto space-y-10 space-x-5 min-h-[80vh]">
          { posts.map((post)=>(
            <Product key={posts.id} post={post}/>
          ) )
          }
          </div>
      </div>
        ) :
      <div className="flex justify-center items-center">
        <p>No Data Found</p>
      </div>
      }
  </div>);
};

export default Home;
